import React from 'react';
import Svg from '../../images/ilustrations/Anye_llaves_new.svg';

const VisitorRegistrationIcon = () => (
    <img src={Svg} alt="VisitorRegistration" style={{ width: '2em', height: '2em' }} />
);

export default VisitorRegistrationIcon;
